module.exports = __webpack_public_path__ + "assets/arrow_down_white-ce8721.svg";